export const TAP_SYSTEM_USER = '__TAP_SYSTEM__';
export const CASBIN_COLLECTION = 'casbin';
export const EMPTY_NAMESPACE = '';
//# sourceMappingURL=constants.js.map